import * as regularIcons from "@fortawesome/pro-regular-svg-icons";

const kebabToCamel = (str) => {
  return str
    .replaceAll(/-./g, (match) => match[1].toUpperCase()) // Convert -x to X
    .replace(/^fa/, "fa"); // Ensure "fa" prefix remains lowercase
};

export const getIconByName = (iconName) => {
  // Returns null if iconName is not a proper string or is empty
  if (!iconName || typeof iconName !== "string") {
    return null;
  }

  // Return null if it doesn't start with "fa-"
  if (!iconName.startsWith("fa-")) {
    return null;
  }

  const camelCaseIconName = kebabToCamel(iconName);

  // Return the icon if it exists, otherwise return null
  return regularIcons[camelCaseIconName] || null;
};
